export default "__VITE_ASSET__CLWsePOp__"